namespace Nobox.Nobox.Pages {
    export namespace FormPublicEndpointService {
        export const baseUrl = '~/Form';

        export declare function SendFormAsync(request: SendFormRequest, onSuccess?: (response: SendFormResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SendFollowUp(request: SendFollowUpRequest, onSuccess?: (response: SendFormResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UploadFile(request: FormUploadFileRequest, onSuccess?: (response: FormUploadFileResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UploadMultiFile(request: FormUploadMultiFileRequest, onSuccess?: (response: FormUploadMultiFileResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            SendFormAsync = "~/Form/SendFormAsync",
            SendFollowUp = "~/Form/SendFollowUp",
            UploadFile = "~/Form/UploadFile",
            UploadMultiFile = "~/Form/UploadMultiFile"
        }

        [
            'SendFormAsync', 
            'SendFollowUp', 
            'UploadFile', 
            'UploadMultiFile'
        ].forEach(x => {
            (<any>FormPublicEndpointService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
